/**
 * Header Layout
 *
 * @file header.js
 */

 import $ from 'jQuery';
 import AOS from 'aos';
 import 'aos/dist/aos.css';
 import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
 import "@fancyapps/ui/dist/fancybox.css";


 const home = (() => {
  const aosJs = () => {
   AOS.init();
  };

  const futureJs = () => {
   $(".home-future-talent .item").each(function(){
    $(this).find(".bottom").css("margin-bottom",-$(this).find(".bottom").innerHeight());
   }).hover(function() {
    $(this).find(".bottom").css("margin-bottom",0);
    }, function() {
      $(this).find(".bottom").css("margin-bottom",-$(this).find(".bottom").innerHeight());
    });
  };
 
   const init = () => {
    aosJs();
    futureJs();
   };
 
   return {
     init,
   };
 })();
 
 export default home;
 